import React from 'react';
import { tr } from '../../i18n';
import './system-states.css';

type ReadOnlyBannerProps = {
  text?: string;
};

const ReadOnlyBanner: React.FC<ReadOnlyBannerProps> = ({
  text = tr.shell.systemStates.readOnly
}) => (
  <div className="read-only-banner" role="status">
    <span aria-hidden="true">👁</span>
    <span>{text}</span>
  </div>
);

export default ReadOnlyBanner;
